import { useEmbarcacaoMotores } from "../../../../hooks/use-embarcacao-motores";
import { buildDetailFields } from "../../../detail-format/detail-fields";
import { EMPTY_FIELD_PLACEHOLDER, latestAtualizacao } from "../../../detail-format/detail-format";
import type { EmbarcacaoDetailSectionProps } from "../../embarcacao-detail-section";
import {
  MOTORES_EMPTY_STATE,
  MOTORES_FIELDS,
  MOTORES_ID,
  MOTORES_LOADING_MESSAGE,
  MOTORES_TEST_ID,
  MOTORES_TITLE,
  MOTOR_FALLBACK_LABEL,
} from "./motores-section.constants";
import { byOrdemMotor } from "./motores-section.utils";

/**
 * Seção Motores do detalhamento da embarcação: um cartão por motor, em ordem crescente de Ordem Motor (RN002),
 * somente para leitura.
 */
export function useMotoresSection({
  embarcacaoId,
  onReauthenticate,
}: EmbarcacaoDetailSectionProps) {
  const { status, motores, errorMessage, reload } = useEmbarcacaoMotores(embarcacaoId);
  const ordenados = motores ? [...motores].sort(byOrdemMotor) : null;

  return {
    id: MOTORES_ID,
    title: MOTORES_TITLE,
    testId: MOTORES_TEST_ID,
    cardsTestId: `${MOTORES_TEST_ID}-blocks`,
    status,
    errorMessage,
    loadingMessage: MOTORES_LOADING_MESSAGE,
    emptyContent: MOTORES_EMPTY_STATE,
    onReauthenticate,
    onRetry: reload,
    // Só há data de atualização a exibir quando a seção tem motores.
    ultimaAtualizacao: ordenados
      ? latestAtualizacao(
          ordenados.flatMap((row) => [row.ultimaAtualizacao, row.atualizacaoMotores]),
        )
      : undefined,
    cards: (ordenados ?? []).map((motor, index) => {
      const testId = `${MOTORES_TEST_ID}-block-${index}`;

      return {
        testId,
        title: motor.motor ?? `${MOTOR_FALLBACK_LABEL} ${index + 1}`,
        titleTestId: `${testId}-motor`,
        fieldsTestId: `${testId}-fields`,
        fields: buildDetailFields(motor, MOTORES_FIELDS, testId, EMPTY_FIELD_PLACEHOLDER),
      };
    }),
  };
}
